<template>
  <div>
    <div v-if="activateVehicles === 'true'">
      <div class="d-flex align-items-center">
        <h3 class="title-content">{{ scheduling ? 'Agendar Estacionamento' : 'Estacionar Veículo' }}</h3>
      </div>
      <v-stepper v-model="step" vertical>
        <v-stepper-step color="#08437B" step="1">
          <span class="title-stepper">Selecionar veículo</span>
        </v-stepper-step>
        <v-stepper-content step="1">
          <select-vehicle v-model="selected_vehicle" :look_for_plate="this.$route.params.plate"/>
          <action-footer @nextStep="nextStep" @previousStep="prevStep" :can-next-step="canNextStep(1)" :can-previous-step="canPreviousStep(1)"/>
        </v-stepper-content>

        <v-stepper-step color="#08437B" step="2">
          <span class="title-stepper">Selecionar tempo</span>
        </v-stepper-step>
        <v-stepper-content step="2">
          <select-product v-if="step===2" v-model="product_body" :vehicle="selected_vehicle"/>
          <action-footer @nextStep="nextStep" @previousStep="prevStep" :can-next-step="canNextStep(2)" :can-previous-step="canPreviousStep(2)"/>
        </v-stepper-content>

        <v-stepper-step color="#08437B" step="3">
          <span class="title-stepper">Confirmar</span>
        </v-stepper-step>
        <v-stepper-content step="3">
          <confirm :product_body="product_body" :vehicle="selected_vehicle" :messages="validate_messages" v-if="product_body.product && selected_vehicle"/>
          <action-footer @nextStep="nextStep" @previousStep="prevStep" :can-next-step="canNextStep(3)" :can-previous-step="canPreviousStep(3)"/>
        </v-stepper-content>

      </v-stepper>


      <generic-error-dialog-v2
          v-model="error_activation"
          :error-text="error_activation"
      />

      <v-snackbar
          v-model="show_success"
          :color="'success'"
          :multi-line="true"
          :right="true"
          :timeout="2000"
          :top="true"
          class="snackbar-success"
      >
        <span><i class="fas fa-check mr-2"></i> Ativação realizada com sucesso!</span>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SelectVehicle from "@/components/Activation/SelectVehicle.vue";
import SelectProduct from "@/components/Activation/SelectProduct.vue";
import Confirm from "@/components/Activation/Confirm.vue";
import ActionFooter from "@/components/Activation/ActionFooter.vue";
import GenericErrorDialogV2 from "@/components/GenericErrorDialogV2.vue";

export default {
  name: "Activation",
  components: {
    GenericErrorDialogV2,
    ActionFooter,
    Confirm,
    SelectProduct,
    SelectVehicle

  },
  props: {
    plate: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      step: 1,
      selected_vehicle: null,
      product_body: {
        product: null,
        category: null,
        group: null,
      },
      validate_messages: [],
      error_activation: null,
      show_success: false,
      loading: false,
    }
  },
  methods: {
    showError(text) {
      this.error_activation = text;
      this.step             = 1;
    },
    nextStep: async function () {
      if (this.step === 2) {
        if (!(await this.validateActivation())) {
          return;
        }
      } else if (this.step === 3) {
        return await this.activate();
      }

      this.step++;
    },
    prevStep: function () {
      this.step--;
    },
    validateActivation: async function () {
      this.validate_messages = [];
      this.loading           = true
      let obj                = {
        plate: (this.selected_vehicle.plate).toUpperCase(),
        product_id: this.product_body.product.id,
      };

      try {
        const {data}           = await axios
            .post("/api/audit/activation/validate", obj)
        this.validate_messages = data.messages;

        if (!data.hasBalance) {
          this.showError("Você não possui saldo suficiente para estacionar.");
          return false;
        }
        return true;
      } catch (e) {
        this.showError(e.response.data.message);
        return false;
      } finally {
        this.loading = false;
      }
    },
    activate: async function () {
      let obj = {
        plate: this.selected_vehicle.plate,
        product_id: this.product_body.product.id,
      };

      this.loading = true;

      try {
        await axios.post('/api/audit/activation/manual/wallet/activate', obj)
        this.show_success = true;
        setTimeout(() => {
          this.$router.replace({name: 'home'});
        }, 1000);

      } catch (error) {
        this.showError(error.response.data.message
            || 'Ocorreu um erro. Tente novamente.');
      } finally {
        this.loading = false;
      }

    },
    canNextStep(step) {
      switch (step) {
        case 1:
          return !!(this.selected_vehicle);
        case 2:
          return !!(this.product_body.product && !this.error_activation);
        case 3:
          return !this.error_activation;
      }


      return step < 4;
    },
    canPreviousStep(step) {
      return step > 1;
    },
  },
  computed: {
    activateVehicles() {
      return process.env.VUE_APP_ACTIVATE_VEHICLE;
    },
    name: function () {
      return process.env.VUE_APP_NAME;
    },
  }
}
</script>

<style scoped>
</style>
